import { Label, LabelColor, type LabelProps } from '@shared/components';

import { QUESTION_REVIEW_STATUS_COLOR, QUESTION_REVIEW_STATUS_TEXT } from './constants';

export interface QuestionReviewStatusTagProps extends LabelProps {
  status: 'todo' | 'in-review' | 'reviewed' | 'done';
}

export default function QuestionReviewStatusTag(props: Readonly<QuestionReviewStatusTagProps>) {
  const { status, ...restProps } = props;

  const color = QUESTION_REVIEW_STATUS_COLOR[status] ?? LabelColor.GREY;
  const text = QUESTION_REVIEW_STATUS_TEXT[status] ?? '-';

  return (
    <Label color={color} variant='outlined' {...restProps}>
      {text}
    </Label>
  );
}
